import React from "react";
import { Box, Button, Separator, Text } from "@showitinc/showit-wc";
import { toUnicode } from "../../../utils/DomainUtils";
import ViewPanel from "../../blogsetup/ViewPanel";
import SetupButtonBar from "../../blogsetup/SetupButtonBar";
import Constants from "../Constants";
import HelpConstants from "../../../constants/HelpConstants";
import useOpenAccount, { PATH_DOMAINS, WINDOW_NEW } from "../../../hooks/useOpenAccount";

function Confirm({ blogSetup, actions }) {
  const { blogSetupData, domainConfig, path, dns } = blogSetup;
  const migrationRequired = path === Constants.PATH_ADV_MIGRATE;
  const domainName = toUnicode(domainConfig.domain_name || blogSetupData.blog_domain_name || "");
  const [openAccountDomains] = useOpenAccount({ path: PATH_DOMAINS, windowTarget: WINDOW_NEW });
  const hasDnsRecords = Array.isArray(dns) && dns.length > 0;

  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Review
            </Text>
            <Separator />
            <Box mb="2">
              <Text>
                {migrationRequired
                  ? "Once your blog is migrated it will be available at:"
                  : "Once your blog is setup it will be available at:"}
              </Text>
              <Text variant="body-large" variantStyle="strong">
                {domainName}
              </Text>
            </Box>
            <Text>
              Setting up your {migrationRequired ? "blog migration" : "new blog"} is not immediate.{" "}
              <br />
              <a
                href={HelpConstants.URL_BLOG_SETUP}
                target="_blank"
                rel="noreferrer"
              >
                Learn more about estimated turnaround time
              </a>
              .
            </Text>
            {hasDnsRecords && (
              <Box mt="3">
                <Button variant="feature" size="md" onSIClick={openAccountDomains}>
                  Configure DNS Settings
                </Button>
              </Box>
            )}
          </>
        ),
        actions: (
          <SetupButtonBar
            onForward={actions.close}
            allowForward
            forwardBtnText="Close"
          />
        ),
      }}
    </ViewPanel>
  );
}

export default Confirm;
